// extracted by mini-css-extract-plugin
module.exports = {"DescriptionList":"DescriptionList_DescriptionList__3p2nC","BulletList":"DescriptionList_BulletList__3qqxW"};